/* ==========================================================================
   ABEERS Wholesale — GSAP scroll animations
   Loads GSAP + ScrollTrigger from cdnjs if not already present on the page,
   then fades up any .aw-fade-up element as it enters the viewport, and adds
   a subtle parallax to the hero botanical decorations.
   ========================================================================== */
(function () {
  'use strict';

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (document.querySelector('script[data-aw-src="' + src + '"]')) { resolve(); return; }
      var s = document.createElement('script');
      s.src = src;
      s.setAttribute('data-aw-src', src);
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function ensureGsap() {
    if (window.gsap && window.ScrollTrigger) return Promise.resolve();
    return loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js')
      .then(function () {
        return loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js');
      })
      .then(function () {
        window.gsap.registerPlugin(window.ScrollTrigger);
      });
  }

  function runAnimations() {
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var fadeEls = document.querySelectorAll('.aw-fade-up');
    if (!fadeEls.length) return;

    if (prefersReduced || !window.gsap) {
      fadeEls.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    fadeEls.forEach(function (el, i) {
      window.ScrollTrigger.create({
        trigger: el,
        start: 'top 88%',
        once: true,
        onEnter: function () {
          window.gsap.to(el, {
            opacity: 1,
            y: 0,
            duration: 0.9,
            ease: 'power3.out',
            delay: Math.min((i % 4) * 0.08, 0.24),
            onStart: function () { el.classList.add('is-visible'); }
          });
        }
      });
    });

    document.querySelectorAll('.aw-botanical').forEach(function (el) {
      window.gsap.to(el, {
        yPercent: 12,
        ease: 'none',
        scrollTrigger: {
          trigger: el.closest('.aw-section'),
          start: 'top bottom',
          end: 'bottom top',
          scrub: 0.6
        }
      });
    });
  }

  function init() {
    ensureGsap().then(runAnimations).catch(function () {
      // If GSAP fails to load (e.g. blocked CDN), reveal content plainly.
      document.querySelectorAll('.aw-fade-up').forEach(function (el) {
        el.classList.add('is-visible');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
